//export const API = "https://api.tellytell.com";
//export const API = "http://localhost:5050";

//export const API = "https://api-tellytell.onrender.com";
//export const API = "https://api-tellytell-8ax2.onrender.com"


//new Our Latest  server
export const API = "https://api.socomott.com"
export const username = "tazim.member"
